import React from 'react';
import { css, Header } from "@bdfx/fukit"
import {clip, shadow} from "../homepage/section"
import { formatInt } from "../../common/format"

import ctrans from "../../common/trans"
import { Bar } from 'react-chartjs-2'
import ChartDataLabels from 'chartjs-plugin-datalabels';
import Chart from "chart.js"
Chart.pluginService.register(ChartDataLabels);


function PriceHistogram ({locale = "", total = 1, price_histogram = {}}){

    return (
        <Style className="section">
            <div>
                <div>
                    <Header type={2}>
                        {ctrans("price_histogram")}
                    </Header>
                    <Bar height={80} options={getBarOptions(total, locale)} data={getBarData(price_histogram)} />
                </div>
            </div>
        </Style>
    )
}


const Style = css("div")({
  filter: shadow,
  position: "relative",
  zIndex: 4,
  "> div": {
    clipPath: clip,
    background: "#f6f6f6",
    marginTop: "-320px",
    paddingTop: "350px",
    paddingBottom: "120px",
    "> div": {
      maxWidth: "1200px",
      margin: "auto",
      },
  },
})


const getBarData = (data) => ({
    labels: Object.keys(data),
    datasets: [
      {
          name: ctrans("products_count"),
          data: Object.values(data),
          backgroundColor: "#69a120",
      },
    ],
  })
  
  const getBarOptions = (total, locale) => ({
    plugins: {
      datalabels: {
        color: '#3c3c3c',
        align: 'end',
        anchor: 'end',
        font: {
          weight: "bold",
        },
        formatter: (value) => Math.round(value*100/total) + " %"
      }
    },
    legend: {
      display: false
    },
    scales: {
      xAxes: [
        {
          scaleLabel: {
            display: true,
            labelString: `${ctrans("price_level")} (${ctrans("currency_"+locale)})`,
          },
          gridLines: {
              display: false,
          },
  
          ticks: {
            fontStyle: "bold",
            beginAtZero: true,
            callback: function(value, index, values) {
              const splitted = value.split(' - ')
              return splitted.map(s => formatInt(s)).join(' – ')
            }
          },
        },
  
      ],
      yAxes: [
        {
          scaleLabel: {
            display: true,
            labelString: ctrans("products_count"),
          },
          ticks: {
            fontStyle: "bold",
            beginAtZero: true,
            callback: formatInt,
          },
        },
      ],
    },
  })

  export default PriceHistogram